<template>
  <div>
    <div v-if="data_in_json && data_in_json.length"
         class="d-flex align-items-center mt-10">
      <table class="table">
        <thead class="thead-light">
        <tr>
          <th scope="col" colspan="3">
                            <span class="label label-inline label-light-primary font-weight-bold">
                                {{ $t(head_title) || 'N/A' }}
                            </span>
          </th>
        </tr>
        <tr>
          <th v-for="(form_fields_each,index) in form_fields" scope="col"
              :key="index"
          >{{ form_fields_each.label }}
          </th>
        </tr>
        </thead>
        <tbody v-for="(data_in_json_each,index) in data_in_json"
               :key="index"
        >
        <tr>
          <td v-for="(form_fields_each,index) in form_fields"
              :key="index"
          >
            {{ data_in_json_each[form_fields_each.name] || 'N/A' }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'short-data-from-json',
  props: {
    head_title: String,
    data_in_json: Array,
  },
  data: () => ({
    form_fields: {
      'title': {
        'name': 'title',
        'label': 'Title',
      },
      'note': {
        'name': 'note',
        'label': 'Note',
      }
    },
  }),
}
</script>
